/* Publish by EComposer at 2026-10-21 00:58:23*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zuii2nl8308"]=  window.__ectimmers["ecom-zuii2nl8308"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-zuii2nl8308').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zuii2nl8308', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-je5i1d8gvpd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-je5i1d8gvpd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iy42fo7m4qh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iy42fo7m4qh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klh1a1yuvms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klh1a1yuvms', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bupaoaijty').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bupaoaijty', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pbcclonu68h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pbcclonu68h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-shmkdwfg5u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-shmkdwfg5u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryp7rns48el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryp7rns48el', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nt06t600hi"]=  window.__ectimmers["ecom-nt06t600hi"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-nt06t600hi"]["vis08ef2a"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-nt06t600hi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nt06t600hi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-baxweaj2ewa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-baxweaj2ewa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apclg0stfpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apclg0stfpa', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}